import useRead from "../useRead";

const useGetVariantList = ({ limit = 50, productId } = {}) => {
  const initialData = {
    pageNo: 0,
    limit: limit,
    searchQuery: "",
    product_id: productId,
  };

  const handlePageClick = (val) => {
    let pageNo = {
      ...paramsObject,
      pageNo: val.selected,
    };
    setGetListParams(pageNo);
  };

  const handleSearchVal = (e) => {
    let value = e.target.value;
    let copyPrams = {
      ...paramsObject,
      searchQuery: value,
      pageNo: 0,
    };
    setGetListParams(copyPrams);
  };

  const handleSetLimit = (e) => {
    let value = e.target.value;
    let copyPrams = {
      ...paramsObject,
      limit: value,
    };
    setGetListParams(copyPrams);
  };

  const { data, paramsObject, setGetListParams } = useRead({
    initialData,
    url: "product/variant/list",
    method: "GET",
  });

  return {
    configData: data?.data?.data || [],
    handlePageClick,
    handleSearchVal,
    handleSetLimit,
    paramsObject,
  };
};

export default useGetVariantList;
